import { modalState } from '@/state/modal.state';

import { ConfirmDeleteModal } from '../confirm-delete-modal';

import { useDeleteTeamFile } from './use-delete-team-file';
import { useAtomValue } from 'jotai';

export function DeleteTeamFileModal() {
  const modal = useAtomValue(modalState);

  const { deleteTeamFile } = useDeleteTeamFile();

  if (!modal || modal.state !== 'deleteTeamFile') return null;

  return (
    <ConfirmDeleteModal onConfirm={deleteTeamFile.bind(null, modal.file.id)} />
  );
}
